import { TenantSettingsTabs } from '.';

export const subscriptionPage = `/tenant-settings/${TenantSettingsTabs.Subscription}`;
